import Phaser from "phaser"

import { cScene } from "../cScene";
import { ScreenItem } from "../dataTypes";
import { net } from "../utils/net";

import { ModuleCollection, Base } from "./modules";


var spriteCount: number = 0;

export class cSpriteLoad extends Phaser.GameObjects.Sprite {

  public dragitem!: any[]
  public modules: ModuleCollection;
  private hash: string = 'cload_sp_' + (spriteCount++)
  public basePath:string | null = null;
  public useFullPathOnAsset:boolean
  public ev: Phaser.Events.EventEmitter

  constructor(sc:cScene, data: ScreenItem){
    super(sc,0,0,'');
    this.useFullPathOnAsset = false
    this.ev = new Phaser.Events.EventEmitter()
    this.modules = Base.initModules(this,data)
  }

  public set fromScene(v:string){
    this.basePath = net.gamedataFolder + v + '/';
    console.log('SET STUFF',this.basePath)
  }


  public set asset(v:string){
    console.log('setAsset',v)
    if (!v) return
    //let url =  net.serverUrl + '/screens/' + data.asset ;
    console.log('loading asset...',v , net.serverUrl)
    if (v.indexOf('.png') === -1 && v.indexOf('.jpg') === -1){
      v += '.png'
    }
    this.visible = false;
    var path = (this.basePath ? net.serverUrl+this.basePath : (this.scene as cScene).savedPath) + 'assets/' + v;
    var img = new Image(100,100);
    var $this = this
    img.addEventListener('load',()=>{            
      this.scene.textures.remove( this.hash );
      this.scene.textures.addImage( this.hash , img);
      this.setTexture( this.hash);
      this.visible = true;
      $this.modules.drag.init();
      this.ev.emit('loaded')
    });
    img.crossOrigin = "Anonymous";
    img.src = this.useFullPathOnAsset ? v :path;    
  }


}